/** TanStack Query hook for fetching comparison data. */

import { useQuery } from "@tanstack/react-query";
import { api } from "@/services/api";

interface CompareResult {
  jobId: string;
  pluginId: string;
  createdAt: string;
  parameters: Record<string, unknown>;
  status: string;
  content?: string | Record<string, unknown>;
  format?: string;
  downloadOnly?: boolean;
  error?: string;
}

export function useCompare(jobIds: string[]) {
  const ids = jobIds.join(",");
  return useQuery<{ results: CompareResult[] }>({
    queryKey: ["compare", ids],
    queryFn: () => api.get(`/reporting/jobs/compare?ids=${ids}`),
    enabled: jobIds.length >= 2 && jobIds.length <= 4,
  });
}
